import { z } from 'zod';
import { TimestampSchema } from '../primitives.js';
/**
 * `accounts/{uid}` — account-level state, one per signed-in user (doc 07 §4.2).
 * Created lazily by the first `createBusiness` call. Owner-readable; writes are SERVER-ONLY, same posture as
 * provisioning fields. This is the future home of account-level plan / billing
 * fields. There is deliberately no cap on businesses per account: the old
 * `maxBusinesses` field (5) was removed, and documents that still carry it
 * parse fine — zod drops the unknown key.
 */
export const AccountSchema = z.object({
    createdAt: TimestampSchema,
    updatedAt: TimestampSchema.optional(),
});
/** Account doc plus its Firestore id (the owner uid). */
export const AccountWithIdSchema = AccountSchema.extend({ id: z.string() });
//# sourceMappingURL=account.js.map